import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-label-value-v2',
  templateUrl: './label-value-v2.component.html',
  styleUrls: ['./label-value-v2.component.scss'],
})
export class LabelValueV2Component {
  @Input() title: string;
  @Input() value: string;
  @Input() displayType: string = 'string';
  @Input() colSize: number = 4;
  @Input() type: string = 'string';
  @Input() customComponent: string;
  @Input() customInputs: { [key: string]: any };
  @Output() componentOutput = new EventEmitter<{ name: string; value: any }>();

  constructor() {}

  handleComponentOutput(event: { name: string; value: any }) {
    this.componentOutput.emit(event);
  }
}
